import { memo, useContext, useEffect } from 'react';
import { Table, WithTableLayout } from '@qrios/frontend-library';

import { Dialog } from '../../../../../common/dialog';
import { useDialog } from '../../../../../common/dialog/useDialog';

import locales from './locales';
import { columns } from './columns';
import CreditDetails from './credit-details';
import { ClientBalanceContext } from '../../../client-balance';
import { mapApiDataIntoTableFormat } from './dataTransformator';
import { useShowCreditDetails } from '../../../client-balance/credits-history/hooks';
import { WalletCreditsHistoryTableRowActions } from '../../../client-balance/add-funds-to-your-wallet/interfaces';

const WalletCreditsHistory = () => {
  const { creditsHistory, updateCreditsHistory, creditsHistoryLoading, creditsHistoryError } = useContext(
    ClientBalanceContext
  );
  const { isDialogOpen, handleOpenDialog, handleCloseDialog } = useDialog();
  const { creditDetails, creditDetailsError, creditDetailsLoading, handleCreditDetails } = useShowCreditDetails();

  const tableRowActions: WalletCreditsHistoryTableRowActions = {
    openDetails: creditOriderId => {
      handleOpenDialog();
      handleCreditDetails(creditOriderId);
    }
  };

  useEffect(() => {
    updateCreditsHistory();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <WithTableLayout>
        <Table
          dataGridProps={{
            rows:
              !creditsHistory?.credits || creditsHistoryLoading
                ? []
                : mapApiDataIntoTableFormat(creditsHistory, tableRowActions),
            columns,
            sortModel: [{ field: 'date', sort: 'desc' }],
            loading: creditsHistoryLoading,
            error: {
              message: creditsHistoryError,
              refresh: () => updateCreditsHistory()
            }
          }}
          footerProps={{
            refreshProps: {
              handler: updateCreditsHistory,
              disabled: creditsHistoryLoading
            }
          }}
        />
      </WithTableLayout>

      <Dialog
        handleClose={handleCloseDialog}
        open={isDialogOpen}
        title={locales.dialog.details.title}
        ignoreMinHeight={true}
      >
        <CreditDetails
          loading={creditDetailsLoading}
          error={creditDetailsError}
          credit={creditDetails}
          handleClose={handleCloseDialog}
        />
      </Dialog>
    </>
  );
};

export default memo(WalletCreditsHistory);
